import React from 'react'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Grid2 as Grid,
  Typography,
  useTheme,
} from '@mui/material'
import PremiumCalculator from './PremiumCalculator'
import useCustomStyles from '../../hooks/CustomStylesHook'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Colors from '../../utils/colors.json'
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined'
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined'
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined'

const styles = (theme: any) => ({
  faqContainer: {
    backgroundColor: '#f8f9fa',
    borderRadius: '8px',
    padding: '1rem',
  },
  faqAccordion: {
    background: '#17407B26',
  },
  faqLabel: {
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '18.2px',
    color: Colors?.FAQ_LABEL,
  },
  faqValue: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '21.1px',
    color: Colors?.FAQ_VALUE,
  },
  btnShare: {
    textTransform: 'capitalize',
    fontSize: '12px',
    lineHeight: '16.8px',
    fontWeight: 500,
    background: Colors.WHITE_BACKGROUND,
    borderRadius: '20px',
    color: theme.customColors.textColorMain,
    border: `1px solid ${Colors.TEXT_COLOR_SECONDARY}`,
  },
  btnDownload: {
    textTransform: 'capitalize',
    fontSize: '12px',
    lineHeight: '16.8px',
    fontWeight: 500,
    background: Colors.TEXT_COLOR_SECONDARY,
    borderRadius: '20px',
    border: `1px solid ${Colors.TEXT_COLOR_SECONDARY}`,
  },
  boxContainer: {
    background: theme.palette.primary.light,
    width: 'fit-content',
    borderRadius: '20px',
  },
})

const PolicyInformation = () => {
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)

  return (
    <Grid container direction={'column'} spacing={3} pr={2}>
      <Grid size={{ xs: 12 }}>
        <Box
          display={'flex'}
          justifyContent={'start'}
          alignItems={'center'}
          gap={3}
          className={classes?.boxContainer}
          p={2}
        >
          <Typography>Download Policy Documnet</Typography>
          <Button
            variant='contained'
            endIcon={<FileDownloadOutlinedIcon />}
            className={classes?.btnDownload}
          >
            Policy doc.pdf
          </Button>
          <Button
            variant='contained'
            endIcon={<ShareOutlinedIcon />}
            className={classes?.btnShare}
          >
            Share
          </Button>
        </Box>
      </Grid>
      <Grid size={{ xs: 12 }}>
        <PremiumCalculator />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <div className={classes?.faqContainer}>
          <Typography variant='h6' gutterBottom mb={3}>
            Frequently Asked Questions
          </Typography>
          <Grid container direction={'row'} spacing={2}>
            {[...Array(5)].map((_, index) => (
              <Grid size={{ xs: 6, lg: 6, xl: 6, md: 12, sm: 12 }} key={index}>
                <Accordion className={classes?.faqAccordion}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls={`faq-content-${index}`}
                    id={`faq-header-${index}`}
                  >
                    <Typography className={classes?.faqLabel}>
                      How long until we deliver your first blog post?
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography className={classes?.faqValue}>
                      Really boy law county she unable her sister. Feet you off
                      its like six. Among sex are leave law built now. Inbuilt
                      table in an rapid blush. Merits behind on afraid or
                      warmly.
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              </Grid>
            ))}
          </Grid>
        </div>
      </Grid>
      <Grid size={{ xs: 12 }}>
        <Box
          display={'flex'}
          justifyContent={'start'}
          alignItems={'center'}
          gap={3}
          className={classes?.boxContainer}
          p={2}
        >
          <Typography>Inclusions and Exclusions</Typography>
          <Button
            variant='contained'
            endIcon={<VisibilityOutlinedIcon />}
            className={classes?.btnDownload}
          >
            Policy.xls
          </Button>
        </Box>
      </Grid>
    </Grid>
  )
}

export default PolicyInformation
